// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__ZwANx"};
module.exports.__checksum = "049dec733a93"
